import { stringify } from "query-string";
const root = "coin-products";
const productsEndpoints = {
    all(filters) {
        let queryParams = filters ? "?" + stringify(filters) : "";
        return `${root}${queryParams}`;
    },
};
export { productsEndpoints };
